import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import RecipeGrid from "./components/RecipeGrid";
import "./App.css";

function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <RecipeGrid />
    </>
  );
}

export default App;